import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../lib/helpers';
import { dataIntervalExport, dataExtraString3 } from './params';
import { postApi } from '../lib/fetcher';
import CustomEncryption from '../lib/CustomEncryption';
import encryptAES256GCM from '../lib/utils/encryptAES';
import generateVersionHash from '../lib/utils/generateVersionHash';

const users = {
  namespaced: true,

  state() {
    return {
      allUsers: [],
      totalUsers: 0,
      loading: false,
      loadingActiveUser: false,
      userCache: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      allActiveUser: [],
      requestActiveUser: null,
      allActiveUserInputer: [],
      totalPage: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,

      listWilayah: [],
    };
  },

  mutations: {
    setUsers(state, { payload }) {
      state.allUsers = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    setCancelationUser(state, payload) {
      state.requestActiveUser = payload;
    },

    clearUsers(state) {
      state.allUsers = [];
      state.totalUsers = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalUsers(state, { payload }) {
      state.totalUsers = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingActiveUser(state, loadingActiveUser) {
      state.loadingActiveUser = loadingActiveUser;
    },

    removeUser(state, { index }) {
      state.totalUsers -= 1;
      state.allUsers = state.allUsers.filter((value) => value.id != index);
    },
    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },
    addUser(state) {
      state.totalUsers += 1;
    },

    pushUser(state, { payload }) {
      state.allUsers.push(payload);
    },

    editUser(state, { payload, index }) {
      Object.assign(state.allUsers[index], payload);
    },

    setActiveUser(state, payload) {
      state.allActiveUser = payload;
    },

    setActiveUserInputer(state, payload) {
      state.allActiveUserInputer = payload;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setWilayah(state, { payload }) {
      state.listWilayah = payload.data;
    },

    clearWilayah(state) {
      state.listWilayah = [];
    },
  },

  actions: {
    async fetchUsers(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearUsers');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalUsers', {
          payload: responseData,
        });
        ctx.commit('setUsers', { payload: responseData });
      }
    },

    async createUser(
      ctx,
      { date, user, encrypted_password, password_confirmation }
    ) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        fullname: user.fullname,
        username: user.username,
        email: user.email,
        mobile_phone: user.mobile_phone,
        role: user.role,
        status: user.status,
        password: encrypted_password,
        confirm_password: password_confirmation,
        mapping_user: user.mapping_user,
        version: btoa(
          CryptoJS.SHA256(
            user.fullname +
              user.username +
              user.email +
              user.mobile_phone +
              user.role +
              user.password +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/create`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        const newUser = responseData.data;
        ctx.commit('pushUser', {
          payload: newUser,
        });
        ctx.commit('addUser');
        return { success: true, data: responseData };
      }
      return { success: false, data: responseData };
    },

    async updateUser(ctx, { date, user, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: user.id.toString(),
        fullname: user.fullname,
        username: user.username,
        email: user.email,
        mobile_phone: user.mobile_phone,
        role: user.role,
        status: user.status,
        mapping_user: user.mapping_user,
        version: btoa(
          CryptoJS.SHA256(
            user.id.toString() +
              user.fullname +
              user.username +
              user.email +
              user.mobile_phone +
              user.role +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/update`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        const updatedUser = responseData.data;
        ctx.commit('editUser', {
          payload: updatedUser,
          index,
        });
        return { success: true, data: responseData };
      }
      return { success: false, data: responseData };
    },

    async deleteUser(ctx, { date, user, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: user.id.toString(),
        version: btoa(
          CryptoJS.SHA256(
            user.id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/delete`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        ctx.commit('removeUser', {
          index,
        });
        resVal = true;
      }
      return resVal;
    },

    async getActiveUser(ctx, { date, userID, inputer, all }) {
      if (ctx.state.requestActiveUser) ctx.state.requestActiveUser.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationUser', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoadingActiveUser', true);

      const data = JSON.stringify({
        search: { userID },
        sort_by: 'userID asc',
        limit: '50',
        page: '1',
        inputer,
        all,
        version: btoa(
          CryptoJS.SHA256(
            `${'501'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/list-role`;
      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        if (inputer) {
          ctx.commit('setActiveUserInputer', responseData.data.list);
        } else {
          ctx.commit('setActiveUser', responseData.data.list);
        }
      }
      ctx.commit('setLoadingActiveUser', false);
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, view = null }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        const q = sortBy[0] == 'name' ? 'merchant_name' : sortBy[0];
        sort_by = `${q} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => ctrl === 'user' && 'export-user-list';

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        if (responseData.data.message != null) {
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData.data.message,
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },

    async changeEmail(ctx, { userId, date }) {
      ctx.commit('setLoading', true);
      
      try {
        const speEncrypt = new CustomEncryption();
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        
        if (!extras) {
          ctx.commit('setLoading', false);
          return { code: '400', message_en: 'Encryption key not available' };
        }
        
        const aesEncryptedUserId = encryptAES256GCM(userId.toString());
        
        const version = generateVersionHash(userId.toString(), date);
        
        const rsaEncryptedUserId = speEncrypt.encrypt(aesEncryptedUserId, '', extras);
        
        if (!rsaEncryptedUserId) {
          ctx.commit('setLoading', false);
          return { code: '400', message_en: 'Encryption failed' };
        }
        
        const data = JSON.stringify({
          id: rsaEncryptedUserId,
          version,
        });

        const urlApi = `/index.php?r=api/v1/change_email/change-email/send-email`;
        const responseData = await postApi(ctx, urlApi, data);

        ctx.commit('setLoading', false);
        return responseData;
      } catch (error) {
        ctx.commit('setLoading', false);
        return { code: '400', message_en: error.message || 'Internal error' };
      }
    },

    async fetchWilayah(ctx, { date }) {
      ctx.commit('clearWilayah');
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/list-wilayah`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setWilayah', { payload: responseData });
      }
    },

    async fetchPostalcode(ctx, { date, kodeWilayah, search }) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        kode_wilayah: kodeWilayah,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/postal-code`;

      const responseData = await postApi(ctx, urlApi, data);

      let res = [];
      if (responseData?.code == 200) {
        res = responseData.data;
      }

      return res;
    },

    async getMappingUser(ctx, { date, userId }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        user_id: userId,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/user/user/mapping-user`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = [];
      if (responseData?.code == 200) {
        resVal = responseData.data;
      }

      return resVal;
    },

    async sendUserDormantLink(ctx, { userId, date }) {
      ctx.commit('setLoading', true);
      
      try {
        const speEncrypt = new CustomEncryption();
        const extras = speEncrypt.decryption({
          enc: process.env.VUE_APP_STRING_EXTRA2,
          masterkey: dataExtraString3,
        });
        
        if (!extras) {
          ctx.commit('setLoading', false);
          return { code: '400', message_en: 'Encryption key not available' };
        }
        
        const aesEncryptedUserId = encryptAES256GCM(userId.toString());
        
        const version = generateVersionHash(userId.toString(), date);
        
        const rsaEncryptedUserId = speEncrypt.encrypt(aesEncryptedUserId, '', extras);
        
        if (!rsaEncryptedUserId) {
          ctx.commit('setLoading', false);
          return { code: '400', message_en: 'Encryption failed' };
        }
        
        const data = JSON.stringify({
          id: rsaEncryptedUserId,
          version,
        });

        const urlApi = `/index.php?r=api/v1/user_dormant/user-dormant/send-email`;
        const responseData = await postApi(ctx, urlApi, data);

        ctx.commit('setLoading', false);
        return responseData;
      } catch (error) {
        ctx.commit('setLoading', false);
        return { code: '400', message_en: error.message || 'Internal error' };
      }
    },
  },
};
export default users;
